
<template>
  <div class="signup">
    <div class=" pb-5">
      <b-container class="mb-5">
        <b-row>
          <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
            <h4><b-icon icon="files" class='mr-2'></b-icon>メールボックス</h4>
          </b-col>
          <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
            <AgencyList v-if="isAgency" @update="onUpdateAll"></AgencyList>
          </b-col>
        </b-row>
      </b-container>

      <div class="container">
        <div class="row mb-2">
          <div class="col-4">
          </div>
          <div class="col-8">
            <div class="row pl-250px">
              <b-img :src="current_user.profile_image" rounded="circle" class="profile-image" alt=""></b-img>
              <p class="contact-name current-mail pl-2">
              <span class="contact-description">{{ current_user.age }}歳/{{ GENDER_LIST[current_user.gender] }}/{{current_user.current_address}}</span><br/>
                  {{ current_user.first_name }} {{current_user.middle_name}} {{ current_user.last_name }}
              </p>
            </div>
          </div>
          <div class="col-4">
            <b-list-group class="mail-box-list">
              <h2 class="box-title">応募者リスト</h2>
              <p class="sub-title">クリックで切り替わります</p>
              <b-list-group-item class='my-0 contact-line' v-for="l in lists" :key="l">
                <div class="row" @click="fetch_messages(l)">
                    <b-img :src="l.profile_image" rounded="circle" class="profile-image" alt=""></b-img>
                    <p class="contact-name">
                        {{ l.first_name }} {{l.middle_name}} {{ l.last_name }}
                        <br/><span class="contact-description">{{ l.age }}歳/{{ GENDER_LIST[l.gender] }}/{{l.current_address}}</span>
                    </p>
                    <b-badge v-show="l.count > 0" class="ml-auto mt-auto mb-auto unread-circle" variant="warning">{{ l.count }}</b-badge>
                </div>
              </b-list-group-item>
            </b-list-group>

          </div>
          <div class="col-8">
              <b-row>
                <div v-show="recruit.fase == 'pre_interview'" class="col-12 text-center pb-4">
                  <router-link :to="'./jobOffer/' + recruit.job_id">
                    <b-button class='table-edit-button '>求人を見る</b-button>
                  </router-link>
                  <b-button @click="openInterviewModal()" class='orange-button'>面接日程調整</b-button>
                </div>
                <div v-show="recruit.fase == 'waiting_interview'" class="col-12 text-center pb-4">
                  <router-link :to="'./jobOffer/' + recruit.job_id">
                    <b-button class='table-edit-button '>求人を見る</b-button>
                  </router-link>
                  <b-button @click="openInterviewModal('edit')" class='orange-button'>面接日程を変更</b-button>
                  <b-button @click="cancelInterview" class='orange-button'>面接をキャンセル</b-button>
                </div>
                <div v-show="recruit.fase == 'interview_adjustment'" class="col-12 text-center pb-4">
                  <router-link :to="'./jobOffer/' + recruit.job_id">
                    <b-button class='table-edit-button '>求人を見る</b-button>
                  </router-link>
                </div>
                <div v-show="recruit.fase == 'passed'" class="col-12 text-center pb-4">
                  <router-link :to="'./jobOffer/' + recruit.job_id">
                    <b-button class='table-edit-button '>求人を見る</b-button>
                  </router-link>
                  <p>採用しました!!!!</p>
                </div>
              </b-row>

              <b-row v-if="messages.length == 0">
                 <b-card-text>メッセージのやりとりはまだありません</b-card-text>
              </b-row>
              <b-row v-else>
                <div v-for="m in messages" :key="m" class="col-12">
                    <div v-if="m.from == 'aelu'" class="text-center mx-auto">
                      <p class="mb-1 mt-3">{{ formatDate2(m.created_at) }}</p>
                      <b-alert class="w75 mx-auto" variant="success" show>{{ m.message }}</b-alert>
                    </div>
                    <div v-if="m.from == 'user'" class="float-left row">
                      <b-img :src="current_user.profile_image" rounded="circle" class="profile-image mr-4" alt=""></b-img>
                      <div class="float-left row ml-1">
                        <b-alert v-if="m.message_type == 'text'" class="user-message-baloon" variant="info" show>{{ m.message }}</b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="user-message-baloon" variant="info" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="user-message-baloon" variant="info" show><img class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="user-message-baloon" variant="info" show><img  class="w100" :src="m.file_path"/></b-alert>

                        <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>
                        <small class="w100 message-author">{{ current_user.last_name + " " + current_user.first_name }}</small><br/>
                      </div>

                    </div>
                    <div v-if="m.from == 'organization' && isAgency == false" class="float-right row">
                      <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>
                      <b-alert v-if="m.message_type == 'text'" class="org-message-baloon" variant="dark" show>{{ m.message }}</b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="org-message-baloon" variant="dark" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="org-message-baloon" variant="dark" show><img class="w100" :src="m.file_path"/></b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="org-message-baloon" variant="dark" show><img  class="w100" :src="m.file_path"/></b-alert>
                    </div>

                    <div v-else-if="m.from == 'organization' && isAgency == true" class="float-left row">
                      <b-img :src="m.logo_img" rounded="circle" class="profile-image mr-4" alt=""></b-img>
                      <div class="float-left row ml-1">
                        <b-alert v-if="m.message_type == 'text'" class="user-message-baloon" variant="dark" show>{{ m.message }}</b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="user-message-baloon" variant="dark" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="user-message-baloon" variant="dark" show><img class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="user-message-baloon" variant="dark" show><img  class="w100" :src="m.file_path"/></b-alert>
                        <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>
                        <small class="w100 message-author">{{ m.message_name }}</small><br/>
                      </div>
                    </div>


                    <div v-if="m.from == 'agency' && isAgency == false" class="float-left row">
                      <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>
                      <div class="float-left row ml-1">
                        <b-alert v-if="m.message_type == 'text'" class="org-message-baloon" variant="dark" show>{{ m.message }}</b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="org-message-baloon" variant="dark" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="org-message-baloon" variant="dark" show><img class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="org-message-baloon" variant="dark" show><img  class="w100" :src="m.file_path"/></b-alert>
                        <small class="w100 message-author">{{ m.message_name }}</small><br/>
                      </div>
                    </div>

                    <div v-else-if="m.from == 'agency' && isAgency == true" class="float-right row">
                      <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>
                      <b-alert v-if="m.message_type == 'text'" class="org-message-baloon" variant="dark" show>{{ m.message }}</b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="org-message-baloon" variant="dark" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="org-message-baloon" variant="dark" show><img class="w100" :src="m.file_path"/></b-alert>
                      <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="org-message-baloon" variant="dark" show><img  class="w100" :src="m.file_path"/></b-alert>
                    </div>

                </div>
                <div v-show="recruit.fase == 'waiting_interview'" class="col-12 text-center pb-4">
                    <b-alert class="w75 mx-auto" variant="info" show><a :href="interview.interview_url">面接を始める</a></b-alert>
                </div>

                <div v-show="recruit.fase == 'feedback' && feedback.from_org_fb == null" class="col-12">
                    <div class="text-center mx-auto">
                      <b-alert class="w50 mx-auto" variant="dark" show>
                          面接お疲れ様でした。フィードバックをして、採用可否を判定しましょう
                      </b-alert>
                    </div>
                </div>

                <div v-show="recruit.fase == 'feedback' && feedback.from_org_fb == 'passed'" class="col-12">
                    <div class="text-center mx-auto">
                      <b-alert class="w50 mx-auto" variant="dark" show>
                          採用通知を送信しました。求職者からのフィードバックを待ちましょう
                      </b-alert>
                    </div>
                </div>

                <div v-show="recruit.fase == 'feedback' && feedback.from_org_fb == 'denied'" class="col-12">
                    <div class="text-center mx-auto">
                      <b-alert class="w50 mx-auto" variant="dark" show>
                          不採用通知を送信しました。
                      </b-alert>
                    </div>
                </div>

              </b-row>

              <div>
                <div v-if="recruit.fase == 'feedback' && isFeedback == false" class="col-12 text-center">
                  <b-form-select v-model="feedback.from_org_fb" class="mt-3 mb-3" :options="feedbackOpts"></b-form-select>
                  <b-form-textarea
                    v-model="feedback.from_org_comment"
                    placeholder="ここに面接のフィードバックを入力"
                    rows="3"
                  ></b-form-textarea>

                  <b-button v-show="feedback.from_org_fb == 'passed' || feedback.from_org_fb == 'denied' || feedback.from_org_fb == 'one_more_interview'"  @click="postFeedback" class='orange-button mt-3'>結果を送信</b-button>
                </div>
                <div v-else>
                  <div class="d-flex justify-content-between py-2 mt-4">
                    <input ref="file" type="file" style="display: none" @change="onSelectFile">
                    <b-icon @click="$refs.file.click()" class="upload-icon" icon="card-image" font-scale="2"></b-icon>
                    <div>
                      <b-button @click="sendMessage" variant="secondary" size="sm">送信</b-button>
                    </div>
                  </div>
                  <div v-if="u_file == ''">
                    <b-form-textarea
                      v-model="mes"
                      placeholder="ここにメッセージを入力"
                      rows="6"
                    ></b-form-textarea>
                  </div>
                  <div v-else>
                    <b-alert variant="secondary" @dismissed="initializeFile" dismissible show>{{ file_name }}</b-alert>
                  </div>
                </div>
              </div>
          </div>
        </div>

      </div>
    </div>
    <b-modal v-model="interviewModal" scrollable hide-header infomodal hide-footer class="p-1 mt-4" dialog-class="info-modal">
      <div class="row">
        <div class="col-12 px-3 text-right">
          <button class="btn btn-md mb-0 p-0" @click="hideInterviewModal()"><h3>×</h3></button>
        </div>
        <div class="col-12 ">
          <p class="text-center mt-0 mb-0 px-0 blue-title"><b>面接日程を決めましょう</b></p>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-11 mx-auto text-center">
            <p class="des">第1希望から第3希望まで選択し、送信しましょう</p>
          </div>
          <div class="col-11 mx-auto text-left">
            <label>第1希望</label>
            <VueCtkDateTimePicker id="d1" format="YYYY-MM-DD HH:mm"  locale="ja" minute-interval="10" v-model="interview.possible_dates1" label='第1希望'></VueCtkDateTimePicker>

            <label class="pt-3">第2希望</label>
            <VueCtkDateTimePicker  id="d2" format="YYYY-MM-DD HH:mm" locale="ja"  minute-interval="10" v-model="interview.possible_dates2" label='第2希望'></VueCtkDateTimePicker>

            <label class="pt-3">第3希望</label>
            <VueCtkDateTimePicker  id="d3" format="YYYY-MM-DD HH:mm" locale="ja"  minute-interval="10" v-model="interview.possible_dates3" label='第3希望'></VueCtkDateTimePicker>
          </div>
          <div class="col-12 mx-auto text-center pt-5 pb-3">
            <b-button v-if="isAvailableInterviewButton()" @click="submitInterview" class='orange-button'>この内容で相手に送信する</b-button>
            <b-button v-else class='table-edit-button'>この内容で相手に送信する</b-button>
          </div>
        </div>
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import AgencyList from "@/components/Agency/AgencyList"

export default {
  components: {AgencyList },
  data () {
    return {
      messages: [],
      lists: [],
      mes: "",
      idToken: localStorage.idToken,
      interviewModal: false,
      interview: {},
      recruit: {},
      current_user: {},
      current_user_id: "",
      mode: "create",
      isFeedback: false,
      isAgency: false,
      u_file: "",
      file_name: "",
      feedback: {
        from_org_fb: "",
        from_org_comment: ""
      },
      mainProps: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
      feedbackOpts: [
          {value: "passed", text: "採用"},
          {value: "denied", text: "不採用"},
          {value: "one_more_interview", text: "もう一度面接する"}
      ]
    }
  },
  methods: {
    fetch_mailbox: function(u_id="") {
      axios
        .get(process.env.VUE_APP_API + "/api/org/messages" ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.lists = response.data

          if(this.lists.length == 0) {
            this.current_user = {profile_image: "", age: "", first_name: "", last_name:""}
          } else if(u_id == "") {
            this.fetch_messages(this.lists[0])
          } else {
            this.fetch_user(u_id).then((res) => {
              this.current_user = res.data.user
              this.current_user_id = res.data.user.id
              this.current_user.user_id = this.current_user_id
              this.fetch_messages(this.current_user)
            })
          }
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is error', error)
          this.$store.commit('setLoading', false)
        })
    },
    onSelectFile: function(event) {
      const files = event.target.files ? event.currentTarget.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.u_file = e.target.result;
      };
      this.file_name = file.name;
      reader.readAsDataURL(file);
    },
    formatDate: function(s) {
      return moment(s).format("HH:mm")
    },
    formatDate2: function(s) {
      return moment(s).format("Y年M月D日 HH:mm")
    },
    initializeFile: function() {
      this.u_file = ""
      this.file_name = ""
    },
    hideInterviewModal: function() {
      this.interviewModal = false
    },
    openInterviewModal: function(m="create") {
      this.interviewModal = true
      this.mode = m

      if(this.mode == "create") {
        this.interview = {possible_dates1: "", possible_dates2: "", possible_dates3: ""}
      }
    },
    isAvailableInterviewButton: function() {
      if(this.interview.possible_dates1 != "" && this.interview.possible_dates2 != "" && this.interview.possible_dates3 != "") {
        return true
      } else {
        return false
      }
    },
    cancelInterview: function() {
      if(confirm("面接をキャンセルしますか？")) {
        axios
          .delete(process.env.VUE_APP_API + "/api/org/recruits/" + this.recruit.r_id + "/interviews/" + this.interview.id,{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages(this.current_user)
            this.interviewModal = false
          }).catch(error => {
            console.log('this is error', error)
          })
      }

    },
    postFeedback: function() {
      this.$store.commit('setLoading', true)
      if(this.feedback.id == undefined) {
        axios
          .post(process.env.VUE_APP_API + "/api/org/recruits/" + this.recruit.r_id + "/interviews/" + this.interview.id + "/feedbacks",{feedback: this.feedback},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages(this.current_user)
          }).catch(error => {
            console.log('this is error', error)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API + "/api/org/recruits/" + this.recruit.r_id + "/interviews/" + this.interview.id + "/feedbacks/" + this.feedback.id,{feedback: this.feedback},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages(this.current_user)
          }).catch(error => {
            console.log('this is error', error)
          })
      }
    },
    submitInterview: function() {
      if(this.mode == "create") {
        axios
          .post(process.env.VUE_APP_API + "/api/org/recruits/" + this.recruit.r_id + "/interviews",{interview: this.interview},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages(this.current_user)
            this.interviewModal = false
          }).catch(error => {
            console.log('this is error', error)
          })
      } else {
        this.interview.interview_date = ""
        axios
          .patch(process.env.VUE_APP_API + "/api/org/recruits/" + this.recruit.r_id + "/interviews/" + this.interview.id,{interview: this.interview},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages(this.current_user)
            this.interviewModal = false
          }).catch(error => {
            console.log('this is error', error)
          })
      }

    },
    sendMessage: function() {
      if(this.mes == "" && this.u_file == "") {
        alert("空のメッセージは送れません")
        return 
      }
      this.$store.commit('setLoading', true)

      var arg = {
        "message": this.mes,
        "user_id": this.current_user_id,
        "message_type": "text"
      }
      if(this.u_file != "") {
        arg["message_type"] = "file"
        arg["file_path"] = this.u_file
        arg["file_name"] = this.file_name
      }

      axios
        .post(process.env.VUE_APP_API + "/api/org/messages",{message: arg},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.mes = ""
          this.fetch_messages({id: this.current_user_id, user_id: this.current_user_id})
          this.initializeFile()
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    fetch_user: function(u_id) {
      this.$store.commit('setLoading', true)
      return axios
        .get(process.env.VUE_APP_API + "/api/org/users/" + u_id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
    },
    fetch_messages: function(l) {
      this.$store.commit('setLoading', true)
      this.current_user = l
      this.current_user_id = l.id
      this.feedback = {
        from_org_fb: null,
        from_org_comment: ""
      }
      axios
        .get(process.env.VUE_APP_API + "/api/org/messages/1?user_id=" + l.user_id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.messages = response.data
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is error', error)
        })

      axios
        .get(process.env.VUE_APP_API + "/api/org/recruits?u_id=" + l.recruit_id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.recruit = response.data.data

          if(response.data.interview == undefined || response.data.interview == null) {
            this.interview = {possible_dates1: "", possible_dates2: "", possible_dates3: ""}
          } else {
            this.interview = response.data.interview 
          }

          if(response.data.feedback == null) {
            this.feedback = {}
          } else {
            response.data.feedback.forEach(feedback => {
              if(feedback.interview_id == this.interview.id) {
                this.feedback = feedback 
              }
            })
          }

          this.$store.commit('setLoading', false)

          if(this.feedback.from_org_fb == null) {
            this.isFeedback = false
          } else {
            this.isFeedback = true
          }
          console.log(this.feedback)
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    checkAgency() {
      var idToken = localStorage.idToken
      axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(() => { this.isAgency = true})
    },
    onUpdateAll() {
      this.$store.commit('setLoading', true)
      this.fetch_mailbox()
    }


  },
  async mounted() {
    var u_id = this.$route.query.u_id
    this.fetch_mailbox(u_id)
    this.checkAgency()
  },
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}
.w50 {
  width: 50%;
}
.w75 {
  width: 75%;
}
.w100 {
  width: 100%;
}

.mail-box-list {
  background-color: #EDEDED;
  padding: 30px 20px;

  .box-title {
    color: #4D4D4D;
    font-size: 24px;
    font-weight: 600;
    text-align: center; 
  }
  .sub-title {
    color: #4D4D4D;
    font-size: 16px;
    font-weight: 100;
    text-align: center; 
  }
  .contact-line {
    background-color: #EDEDED;
    border: none;
    border-top: 1px solid #B3B3B3;
    border-bottom: 1px solid #B3B3B3;
    padding: 0.75rem 1.25rem;

    .contact-name {
      color: #1A7BD5;
      padding: 0px 15px;
      margin-bottom: 0px;
    }
    .contact-description {
      font-size: 80%;
      color: #4D4D4D;
    }
  }
}
.user-message-baloon {
  border: 2px solid #4298F7;
  background-color: #FFFFFF;
  color: #4298F7;
  border-radius: 10px;
  
}
.user-message-baloon:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -21px;
  margin-top: -9px;
  border: 9px solid transparent;
  border-right: 13px solid #FFF;
  z-index: 2;
}
.user-message-baloon:after {
  content: "";
  position: absolute;
  top: 50%;
  left: -25px;
  margin-top: -10px;
  border: 10px solid transparent;
  border-right: 14px solid #4298F7;
  z-index: 1;
}
.org-message-baloon {
  border: 2px solid #B3B3B3;
  background-color: #FFFFFF;
  color: #4D4D4D;
  border-radius: 10px;
  
}
.org-message-baloon:before {
  content: "";
  position: absolute;
  top: 50%;
  right: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-left: 12px solid #FFF;
  z-index: 2;
}
.org-message-baloon:after {
  content: "";
  position: absolute;
  top: 50%;
  right: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-left: 14px solid #B3B3B3;
  z-index: 1;

}
.pl-250px {
  padding-left: 250px;
}
.current-mail {
  color: #1A7BD5;
}
.unread-circle {
  border-radius: 50%;
  padding: 7px;
}
.upload-icon > input {
}
.w100 {
  width: 100%;
}
.message-time {
  font-size: 10px;
  padding: 0px 5px;
}
.message-author {
  margin-top: -14px;
}
</style>
